import { Component, inject } from '@angular/core';

import { SharedModule } from '../../shared.module';
import { LoadingPageService } from 'src/app/infrastructure/services/loading-services/loading-page.service';
import { ImageBoxLinkComponent } from '../image-box-link/image-box-link.component';
import { _ImageBoxLinkComponent } from '../abstract-classes/_image-box-link.component';

@Component({
    selector: 'app-image-box-tab-list',
    templateUrl: './image-box-tab-list.component.html',
    standalone: true,
    imports: [
        SharedModule,
        ImageBoxLinkComponent,
    ],
    styleUrls: [
        '../image-box.scss',
        './image-box-tab-list.component.scss'],
})
export class ImageBoxTabListComponent
    extends _ImageBoxLinkComponent
{
    protected override _loadingPageService = inject(LoadingPageService);

    override border$$ = this.input_border$$;
    override guid$$ = this.input_guid$$;
    override guidPath$$ = this._guidPath$$;
    override hideOnLoading$$ = this.input_hideOnLoading$$;
    override loading$$ = this._loading$$;
    override noClick$$ = this.input_noClick$$;
    override size$$ = this.input_size$$;
    override tooltip$$ = this.input_tooltip$$;
    override tooltipPosition$$ = this.input_tooltipPosition$$;
    override url$$ = this.input_url$$;
    override version$$ = this.input_version$$;

    override emit_onClick(_event: any): void {
        this._out_onClickEmit.emit();
    }

}
